import { useCallback, useEffect, useState } from 'react';
import { TournamentsService } from '../model/interfaces';
import { container } from 'tsyringe';

type UseTournamentPrizes = {
  entryFee: number;
  extraBonus: string;
  pairing: string;
  np: number;
};

export const useTournamentPrizes = ({
  entryFee,
  extraBonus,
  pairing,
  np,
}: UseTournamentPrizes): {
  data: number[] | null;
  loading: boolean;
  error: string;
} => {
  const tournamentsService: TournamentsService = container.resolve(
    'tournamentsService'
  );

  const [data, setData] = useState<number[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchPrizes = useCallback(async () => {
    setLoading(true);
    try {
      const res = await tournamentsService.calculateTournamentPrizes(
        np,
        entryFee,
        extraBonus,
        pairing
      );
      setData(res.prizes);
    } catch (e) {
      setError(`Error response calculateTournamentPrizes: ${e}`);
    } finally {
      setLoading(false);
    }
  }, [entryFee, extraBonus, pairing, np, tournamentsService]);

  useEffect(() => {
    fetchPrizes();
  }, [fetchPrizes]);

  return { data, loading, error };
};
